module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/people-253658e3eaf229c57a4d33a89af7f8c5.png";